import {
  Checkbox,
  FormControl,
  Grid,
  ListItemText,
  MenuItem,
  SelectChangeEvent,
} from '@mui/material';
import { ErrorTypography, StyledSelect, StyledFormLabel } from 'components/atoms';
import {
  OptionFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { noop } from 'lodash';
import React, { FC, useEffect, useState } from 'react';

import { MenuProps } from './';

export const SelectMultipleField: FC<
  OptionFieldProps<string[]> & withGridItemCSS & withWrapperCSS
> = ({
  disabled = false,
  error,
  fieldKey,
  gridItemCss,
  hide = false,
  initValue = [],
  label = '',
  onChange = noop,
  options,
  labelCss,
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  const [selected, setSelected] = useState<string[]>(initValue || []);

  useEffect(() => {
    if (hide) {
      onChange([], fieldKey);
      setSelected(initValue || []);
    }
  }, [hide]);

  const selectChange = (event: SelectChangeEvent<string[]>) => {
    const value = event.target.value;
    setSelected([...value]);
    onChange(value, fieldKey);
  };

  return hide ? null : (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        error={!!error}
        required={required}
        style={{ width: '100%', ...wrapperCss }}
      >
        <StyledFormLabel error={!!error} style={labelCss}>
          {label} {required ? '*' : null}
        </StyledFormLabel>
        <StyledSelect
          data-testid={`select-${fieldKey}`}
          multiple
          disabled={disabled}
          value={selected}
          onChange={(event: any) => selectChange(event)}
          MenuProps={MenuProps}
          renderValue={() =>
            selected
              .map(
                (value) =>
                  options.find((option) => option.name === value)?.description || '',
              )
              .join(', ')
          }
        >
          {options.map((option) => (
            <MenuItem key={`${fieldKey}-option-${option.name}`} value={option.name}>
              <Checkbox checked={selected.indexOf(option.name.toString()) > -1} />
              <ListItemText primary={option.description} />
            </MenuItem>
          ))}
        </StyledSelect>
      </FormControl>
      <ErrorTypography>{error}</ErrorTypography>
    </Grid>
  );
};
